import React from 'react';
import agent from '../../agent';
import GenericInput from '../GenericInput';
import AnyInput from '../GenericInput/AnyInput';
import { GOTOPAGE } from '../../constants/actionTypes';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { prepareData } from '../../utils';
import cache from '../../cache';
const Promise = global.Promise;

const mapStateToProps = state => ({
  tables: state.tables,
});

const mapDispatchToProps = dispatch => ({
  goToDetailsPage: payload => 
    dispatch({ type: GOTOPAGE, payload }),
});


class NewRecord extends React.Component {
  constructor() {
    super();

    this.state = { 
      table: {
        columns: []
      },
      data: {},
      relationCache: {},
      isInitialized: false,
    };
    this.createRecord = this.createRecord.bind(this);
    
    this.updateStateWithValue = (fieldValueObj) => {
      const state = this.state;
      const data = { ...state.data, ...fieldValueObj};
      const newState = Object.assign({}, state, {data});
      console.log('updating state', fieldValueObj, newState);
      this.setState(newState);
    };
  }

  createRecord() {
    let tableId = this.props.match.params.tableId;
    agent.Data.createRow(tableId, prepareData(this.state.data))
      .then(res => {
          console.log(res);
          cache.saveRecord(tableId, res);
          this.props.goToDetailsPage(`/table/${tableId}/${res.id}/view`);
      })
      .catch(err => console.log(err));
  }

  static getDerivedStateFromProps(props, state) {
    let { isInitialized } = state;
    if(state.table.id !== props.match.params.tableId) {
      isInitialized = false;
    }
    if (props.tables && props.tables.length > 0 && !isInitialized) {
      let currentTable = state.table;
      props.tables.forEach(table => {
        if(props.match.params.tableId === table.id) {
          currentTable = Object.assign({}, table);
          isInitialized = true;
        }
      });
      const newState = Object.assign({}, state, {isInitialized, table: currentTable, data: {}});
      return newState;
    }
    return null;
  }

  render() {
    return (
      <div className="container">
        <div>
          <br/>
          <div>
            {this.state.isInitialized &&
              this.state.table.columns.map((column) => 
                <GenericInput key={column.name} 
                  column={column} 
                  onChange={this.updateStateWithValue} 
                  value={this.state.data[column.name]}/> 
              )}
          </div>
          <button onClick={this.createRecord} className="btn btn-primary">Save</button> &nbsp;
          {/* <Link to={'/table/'+this.state.table.id+'/'+this.state.data.id+'/edit'} className="btn btn-primary">Save</Link>&nbsp; */}
          <Link to={'/table/'+this.state.table.id+'/list'} className="btn btn-secondary">Cancel</Link>&nbsp;
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewRecord);
